import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { getCartToken } from "@faire/retailer-visitor-shared/serialized-data/getCartToken";
import { useBrandCartQueryParams } from "@faire/retailer-visitor-shared/views/brand/BrandCart/hooks/useBrandCart";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { getQueryKey as getCartQueryKey } from "@faire/web-api--source/api/v2/carts/cartToken/get-hooks";
import { IBrandCartV2 } from "@faire/web-api--source/faire/carts/IBrandCartV2";
import { ICartItemV2 } from "@faire/web-api--source/faire/carts/ICartItemV2";
import { IShipmentGroup } from "@faire/web-api--source/faire/carts/IShipmentGroup";
import { useQueryClient } from "@tanstack/react-query";
import { produce } from "immer";
import { useCallback } from "react";
export var useOptimisticBrandCartUpdate = function(brandToken) {
    var queryClient = useQueryClient();
    var buildQueryParams = useBrandCartQueryParams();
    var addBrandCartItems = useCallback(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(items) {
            var queryKey;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        queryKey = getCartQueryKey(getCartToken(), buildQueryParams({
                            brandToken: brandToken
                        }));
                        return [
                            4,
                            queryClient.cancelQueries({
                                queryKey: queryKey
                            })
                        ];
                    case 1:
                        _state.sent();
                        queryClient.setQueryData(queryKey, function(data) {
                            if (!data) {
                                return undefined;
                            }
                            var brandCart = data.brand_carts.find(function(cart) {
                                return cart.brand_token === brandToken;
                            });
                            if (!brandCart) {
                                return undefined;
                            }
                            return updateItemsInBrandCart(data, brandCart, items);
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(items) {
            return _ref.apply(this, arguments);
        };
    }(), [
        queryClient,
        buildQueryParams,
        brandToken
    ]);
    return {
        addBrandCartItems: addBrandCartItems
    };
};
var updateItemsInBrandCart = function(cart, brandCart, items) {
    return produce(cart, function(draft) {
        var _brandCart_shipment_groups_;
        var updatedCartItems = Object.values(brandCart.cart_items).filter(isNotUndefined).reduce(function(acc, item) {
            var _ref;
            return _object_spread_props(_object_spread({}, acc), _define_property({}, (_ref = item.product_token + "_" + item.product_option_token) !== null && _ref !== void 0 ? _ref : "", item));
        }, {});
        items.forEach(function(item) {
            var _ref;
            var token = (_ref = item.product_token + "_" + item.product_option_token) !== null && _ref !== void 0 ? _ref : "";
            if (item.quantity === 0) {
                delete updatedCartItems[token];
            } else {
                updatedCartItems[token] = ICartItemV2.build(_object_spread_props(_object_spread({}, item), {
                    token: token
                }));
            }
        });
        var tokensToRemove = new Set(items.filter(function(item) {
            return item.quantity === 0;
        }).map(function(item) {
            var _ref;
            return (_ref = item.product_token + "_" + item.product_option_token) !== null && _ref !== void 0 ? _ref : "";
        }));
        var _brandCart_shipment_groups__cart_item_tokens;
        var newBrandCart = IBrandCartV2.build(_object_spread_props(_object_spread({}, brandCart), {
            cart_items: updatedCartItems,
            last_updated_by_retailer_at: Date.now(),
            shipment_groups: [
                IShipmentGroup.build(_object_spread_props(_object_spread({}, brandCart.shipment_groups[0]), {
                    cart_item_tokens: _to_consumable_array(((_brandCart_shipment_groups__cart_item_tokens = (_brandCart_shipment_groups_ = brandCart.shipment_groups[0]) === null || _brandCart_shipment_groups_ === void 0 ? void 0 : _brandCart_shipment_groups_.cart_item_tokens) !== null && _brandCart_shipment_groups__cart_item_tokens !== void 0 ? _brandCart_shipment_groups__cart_item_tokens : []).filter(function(token) {
                        return !tokensToRemove.has(token);
                    })).concat(_to_consumable_array(Object.keys(updatedCartItems).filter(function(token) {
                        return !brandCart.cart_items[token];
                    })))
                }))
            ].concat(_to_consumable_array(brandCart.shipment_groups.slice(1)))
        }));
        draft.brand_carts = [
            newBrandCart
        ].concat(_to_consumable_array(draft.brand_carts));
    });
};
